export const Types = {
    LOAD_LAYOUT: 'layout/LOAD_LAYOUT'
  };

const initialState = {
    imageLogoUrl: '',
    cssUrl: '',
    descricao: '',
    tenant: ''
};

export default function layoutReducer (state = initialState, action) {
    switch (action.type) {
        case Types.LOAD_LAYOUT:
            return {
                ...state,
                ...action
            };
        default:
            return state;
    }
};

export function loadLayoutAction(value) {
    return {
        type: Types.LOAD_LAYOUT,
        ...value
    }
}